module.exports = {
      id: "thodargal-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#thodargal",
      toString: function () {
        return this.url;
      }
    }